import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsLoggedOutHomepageRedesignV2, useSettingLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { LoggedOutHomeImage } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { Anchor } from "@faire/web--source/ui/LinkAnchor";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import classNames from "classnames";
import React from "react";
export var BlogTile = function(param) {
    var blogTile = param.blogTile;
    var isHomepageRedesignV2 = useIsLoggedOutHomepageRedesignV2();
    var homepageRedesignVariant = useSettingLoggedOutHomepageRedesignV2();
    var cta_link_url = blogTile.cta_link_url, image = blogTile.image, below_image_title = blogTile.below_image_title;
    if (!image || !cta_link_url || !below_image_title) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Anchor, {
        href: cta_link_url,
        className: "group",
        onClick: function() {
            trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick("blog_carousel-blog-post", cta_link_url, "".concat(homepageRedesignVariant));
        },
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 12,
            className: classNames("h-full w-[260px]", isHomepageRedesignV2 ? "md:w-full" : ""),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ _jsx(LoggedOutHomeImage, {
                        lazyLoad: true,
                        responsiveImage: {
                            mobileAndAbove: image
                        },
                        optimizeImageOptions: {
                            width: 260,
                            height: 200,
                            resizeMethod: "fill"
                        },
                        altText: image.alt_text,
                        className: classNames("flex h-[200px] w-[260px] lg:origin-left lg:transition-transform lg:duration-[1200ms] lg:ease-[cubic-bezier(0.17,0.67,0.24,1)] lg:group-hover:scale-110", isHomepageRedesignV2 ? "md:h-full md:w-full" : "")
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansRegular",
                    className: "group-focus-visible:[outline:2px_solid_var(--core-interactive-focus)_-2px]",
                    children: below_image_title
                })
            ]
        })
    });
};
